import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Segment, Label } from 'semantic-ui-react';
import hasRESTClient from '../../hocs/has-rest-client';
import InstagramLocationsInput from '../../components/instagram-locations-input';
import { buildLocationLookup } from '../../utils/instagram-location-lookup';

const titleStyle = { paddingBottom: 5, display: 'block' };

export class LocationsSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locations: null,
      error: null,
      isSaving: false,
    };
    this.onLookup = buildLocationLookup(props.buildRESTClient);
  }

  componentDidMount() {
    const { restClient, campaignId } = this.props;
    return restClient.get(`campaigns/${campaignId}`)
      .then(response => {
        const locations = _.get(response, 'data.data.attributes.locations');
        this.setState({ locations: _.isArray(locations) ? locations : [] });
      })
      .catch(() => this.setState({ error: 'Could not load locations.' }));
  }

  // Saves each add/remove straight away, putting the chips back if it fails.
  onChange = locations => {
    const { restClient, campaignId } = this.props;
    const previous = this.state.locations;
    this.setState({ locations, isSaving: true, error: null });
    const payload = { data: { attributes: { locations } } };
    return restClient.patch(`campaigns/${campaignId}`, payload)
      .then(() => this.setState({ isSaving: false }))
      .catch(() => this.setState({ locations: previous, isSaving: false, error: 'Could not save. Please try again.' }));
  }

  render() {
    const { locations, error, isSaving } = this.state;

    return (
      <Segment>
        <h3 style={titleStyle}>Tracked locations</h3>
        <p>Instagram posts and stories tagged at any of these locations are added to the campaign.</p>

        {
          _.isNull(locations)
            ? error && <Label basic color="red">{error}</Label>
            : <InstagramLocationsInput
              hideLabel
              locations={locations}
              onChange={this.onChange}
              onLookup={this.onLookup}
              isSaving={isSaving}
              error={error}
            />
        }
      </Segment>
    );
  }
}

LocationsSettings.propTypes = {
  restClient: PropTypes.func.isRequired,
  buildRESTClient: PropTypes.func.isRequired,
  campaignId: PropTypes.string.isRequired,
};

export default hasRESTClient(LocationsSettings);



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-locations-settings/index.js
 **/